import { classNames } from 'libs/react';
import { Money } from 'components/Money';
import { Text } from 'components/Text';
import { getDealItemBundledExtensionParts, getBundledGroupExtensionTotal } from 'helpers/quoteBundled';
import { React } from 'libs/react';
import './QuoteSummaryPanelStatement.scss';
/**
 * @component QuoteSummaryPanelStatement
 * @since 1.0.0
 */
export function QuoteSummaryPanelStatement(props) {
    const { style, deal, item, items, priceDisplay } = Object.assign({ style: 'normal' }, props);
    const parts = getDealItemBundledExtensionParts(item, deal);
    const itemTotal = parts.itemBaseExtension;
    const packagesTotal = parts.packagesExtension;
    const optionsTotal = parts.optionsExtension;
    const total = items && items.length > 0
        ? getBundledGroupExtensionTotal(items, deal)
        : parts.bundledExtension;
    const className = classNames('quote-summary-panel-statement', 'quote-summary-panel-statement--' + style, props.className);
    if (priceDisplay === 'BUNDLED') {
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "quote-summary-panel-statement-row quote-summary-panel-statement-row--bigtotal" },
                React.createElement("div", { className: "quote-summary-panel-statement-row-label" }, t('Subtotal')),
                React.createElement("div", { className: "quote-summary-panel-statement-row-value" },
                    React.createElement(Money, { value: total })),
                React.createElement(Text, { value: deal === null || deal === void 0 ? void 0 : deal.currency.code, className: "deal-summary-panel-statement-currency" }))));
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "quote-summary-panel-statement-row quote-summary-panel-statement-row--subtotal" },
            React.createElement("div", { className: "quote-summary-panel-statement-row-label" }, item.item.title),
            React.createElement("div", { className: "quote-summary-panel-statement-row-value" },
                React.createElement(Money, { value: itemTotal }))),
        packagesTotal > 0 && (React.createElement("div", { className: "quote-summary-panel-statement-row quote-summary-panel-statement-row--discount" },
            React.createElement("div", { className: "quote-summary-panel-statement-row-label" }, t('Packages')),
            React.createElement("div", { className: "quote-summary-panel-statement-row-value" },
                React.createElement(Money, { value: packagesTotal })))),
        optionsTotal > 0 && (React.createElement("div", { className: "quote-summary-panel-statement-row" },
            React.createElement("div", { className: "quote-summary-panel-statement-row-label" }, t('Options')),
            React.createElement("div", { className: "quote-summary-panel-statement-row-value" },
                React.createElement(Money, { value: optionsTotal })))),
        React.createElement("div", { className: "quote-summary-panel-statement-row quote-summary-panel-statement-row--bigtotal" },
            React.createElement("div", { className: "quote-summary-panel-statement-row-label" }, t('Subtotal')),
            React.createElement("div", { className: "quote-summary-panel-statement-row-value" },
                React.createElement(Money, { value: total })),
            React.createElement(Text, { value: deal === null || deal === void 0 ? void 0 : deal.currency.code, className: "deal-summary-panel-statement-currency" }))));
}
